import {NavLink} from 'react-router-dom';
import style from "./Nav.module.css";

const NavBar = () => {
    return(
         <div className={style.Navegation}>

        
        <NavLink to='/' className={style.HomeButton}>Home</NavLink>
      
        <NavLink to='/projects' className={style.ProyectosButton}>Projects</NavLink>

        <NavLink to='/about' className={style.AboutButton}>About</NavLink>
        

        
        </div>
       
    )
}

export default NavBar;